<template>
  <el-button
    :class="[
      disabled ? '!bg-grayG0 border-0 !text-white' : `!bg-white ${hoverBorderColor} ${hoverBgColor} ${hoverTextColor}`,
      textStyle,
      borderColor,
      borderRadius,
      padding,
      width,
      height
    ]"
    class="flex items-center justify-center gap-2 whitespace-pre-line leading-[normal]"
    :disabled="disabled"
    @click="
      () => {
        if (onClick) onClick();
      }
    "
    ><div :class="gap" class="flex items-center justify-center"><slot /></div
  ></el-button>
</template>

<script>
export default {
  name: 'SecondaryButton',
  props: {
    disabled: { type: Boolean, default: false },
    onClick: { type: [Function, null], default: null },
    // Style
    textStyle: {
      type: String,
      default: 'text-sm !text-blackG0 text-center font-semibold'
    },
    borderColor: { type: String, default: '!border-darkBlueG0' },
    borderRadius: { type: String, default: 'rounded-3xl' },
    padding: { type: String, default: 'py-3 px-5' },
    gap: { type: String, default: 'gap-2' },
    width: { type: String, default: 'min-w-30' },
    height: { type: String, default: 'min-h-12' },
    hoverBorderColor: { type: String, default: 'hover:!border-lightBlueG0' },
    hoverBgColor: { type: String, default: 'hover:!bg-lightBlueG0' },
    hoverTextColor: { type: String, default: 'hover:!text-inherit' }
  }
};
</script>
